import { render, staticRenderFns } from "./VTemplateDocumentsBrowse.vue?vue&type=template&id=79af863e&lang=pug"
import script from "./VTemplateDocumentsBrowse.vue?vue&type=script&lang=ts"
export * from "./VTemplateDocumentsBrowse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./TemplateDocumentsBrowse.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FServices%2FTemplate%2Fviews%2FDocuments%2Fcomponents%2FBrowse%2FVTemplateDocumentsBrowse.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports